/**
 *
 * CommunicationCopyAudience
 *
 */

import React, { useState, useMemo, useEffect, useCallback } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// styles
import "./style.scss";

import { useParams } from "react-router-dom";

// antd component
import { Input } from "antd";

// components
import TCFModal from "components/TCFModal";
import { NotificationSimple } from "components/Notifications";

import api from "utils/api";
// hooks
import { useAsync } from "utils/hooks";

function CommunicationCopyAudience({
  open,
  // actions
  setOpen,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames("copy-audience-wrapper", className);
  const { t, i18n } = useTranslation();

  const { id: initId } = useParams();

  const { isLoading, isSuccess, run, data, reset } = useAsync();

  const newKey = "new";

  const [showError, setShowError] = useState(false);
  const [initialID, setInitialID] = useState(false);
  const [name, setCurrenName] = useState("");

  // Because history not trigger update component
  useEffect(() => {
    if (!!initId && initId != newKey) {
      setInitialID(initId);
    }
  }, [initId]);

  const onChangeName = useCallback(e => {
    const value = e?.target?.value;
    setCurrenName(value);
    if (value?.length <= 5) {
      setShowError(true);
    } else {
      setShowError(false);
    }
  }, []);

  const NameFiled = useMemo(
    () => (
      <div className="audience-title-wrapper">
        <Input
          value={name || ""}
          placeholder={t("audiences.nameOfAudience")}
          disabled={isLoading}
          onChange={onChangeName}
        />
        {showError && (
          <span className="error">
            {t("errors.mandatoryFieldMin", { min: 6 })}
          </span>
        )}
      </div>
    ),
    [name, isLoading, showError, i18n?.language],
  );

  const onCancelModalHandler = useCallback(() => {
    setCurrenName("");
    !!setOpen && setOpen(false);
  }, [setOpen]);

  const onAddElementHandler = useCallback(() => {
    if (!showError && name?.length > 5) {
      setShowError(false);
      !isLoading &&
        run(
          api.communications.createAudienceFromComm(initialID, {
            title: name,
          }),
        );
      !!setOpen && setOpen(false);
    } else {
      setShowError(true);
    }
  }, [name, initialID, setOpen, isLoading, showError, setShowError]);

  return (
    <>
      <NotificationSimple
        Loading={isLoading}
        Successful={isSuccess}
        message={t("common.registered")}
        messageSuccess={t("audiences.savedAudience")}
        description=""
      />
      <TCFModal
        className={childClassNames}
        open={open}
        setOpen={setOpen}
        title={t("audiences.nameOfAudience")}
        submitName={t("audiences.saveAudience")}
        loading={isLoading}
        confirmLoading={isSuccess}
        onCancel={onCancelModalHandler}
        onOk={onAddElementHandler}
      >
        {NameFiled}
      </TCFModal>
    </>
  );
}

CommunicationCopyAudience.defaultProps = {
  open: false,
  loading: false,
  confirmLoading: false,
};

export default CommunicationCopyAudience;
